import { HeaderContent } from "~/components/header/HeaderContent";

// "fleet" is the solid header under the .fleet (dark) token scope, with the
// Fleet Solutions logo and sales CTAs in place of the desktop cart.
export type HeaderVariant = "transparent" | "default" | "fleet";

interface HeaderProps {
    variant?: HeaderVariant;
    // Hides this header from the accessibility tree — e.g. while an
    // accompanying <FollowHeader> is the one actually on screen, so there's
    // only ever one exposed "Main navigation" landmark at a time.
    ariaHidden?: boolean;
    // Extra classes for the outer element — e.g. a page whose hero background
    // is already the same color as the nav, where the default variant's
    // scroll-shadow would show as an unwanted seam.
    wrapperClassName?: string;
}

export default function Header({ variant = "default", ariaHidden = false, wrapperClassName }: HeaderProps) {
    return (
        <HeaderContent
            transparent={variant === "transparent"}
            fleet={variant === "fleet"}
            ariaHidden={ariaHidden}
            wrapperClassName={wrapperClassName}
        />
    );
}
